// The single host Cloudflare serves its Web Analytics beacon from.
const CLOUDFLARE_BEACON_URL_PATTERN = /^https:\/\/static\.cloudflareinsights\.com\//


// Cloudflare Web Analytics' beacon is injected at the edge, so it runs on our
// pages without ever appearing in our bundles. Its Core Web Vitals collection
// calls `Array.prototype.at` untranspiled and throws on any engine old enough to
// lack it, which is most of the old Android browsers our DSAR forms see. It
// throws from the one-shot `click`/`keydown` listener it registers to finalize
// the metric, so `@sentry/browser`'s `addEventListener` instrumentation wraps it
// and leaves a frame from our origin beneath an otherwise entirely third-party
// stack — enough to satisfy the origin check on plumbing alone. Unlike the fetch
// case we need no message check to go with the frame: nothing of ours is served
// from that host and the beacon never calls into our code, so any error naming it
// is theirs whatever it says.
//
export default function hasCloudflareBeaconFrame(frames) {
  return frames.some(({ filename }) => CLOUDFLARE_BEACON_URL_PATTERN.test(filename || ''))
}
